module.exports = __webpack_public_path__ + "static/media/victory.6db44b04.png";